// Deterministic friendship doc id + sorted member pair. Sorting both uids means
// a pair maps to exactly one edge regardless of who initiates, which dedups
// simultaneous requests in either direction.
export function friendPair(a: string, b: string): [string, string] {
  return a < b ? [a, b] : [b, a]
}

export function friendshipPairId(a: string, b: string): string {
  const [lo, hi] = friendPair(a, b)
  return `${lo}_${hi}`
}
